import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import { ICardElement, IScoreCard } from "../../backend/model/model";
import { getChildElements } from "../../backend/model/getChildElements";
import { getRootScorecards } from "../../backend/model/getRootScorecards";
import { getChildScorecards } from "../../backend/model/getChildScorecards";
import { getTopLevel } from "../../backend/model/getTopLevel";
import { useQuery } from "react-query";

const useStyles = makeStyles({
  root: {
    height: 110,
    flexGrow: 1,
    maxWidth: 400,
  },
});

const ShowCard = (props: {
  card: ICardElement;
  onSelect?: (card: ICardElement) => void;
}) => {
  const { isLoading, data } = useQuery(`scorecards${props.card.id}`, () =>
    getChildElements(props.card.id)
  );
  if (isLoading) return null;
  const { card } = props;
  return (
    <TreeItem
      key={card.id}
      nodeId={card.id}
      label={`(${card.typename}) ${card.name}`}
      onClick={() => {
        if (props.onSelect) props.onSelect(card);
      }}
    >
      {data?.map((item) => {
        return <ShowCard card={item} onSelect={props.onSelect} />;
      })}
    </TreeItem>
  );
};

export default function ShowCardNavigator(props: {
  card: IScoreCard;
  onSelect?: (card: ICardElement) => void;
}) {
  const classes = useStyles();
  const { isLoading, data } = useQuery(`el${props.card.id}`, () =>
    getTopLevel(props.card.id)
  );

  if (isLoading) return null;
  return (
    <TreeView
      className={classes.root}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpanded={["root"]}
      defaultExpandIcon={<ChevronRightIcon />}
    >
      {data?.map((item: ICardElement) => {
        return <ShowCard card={item} onSelect={props.onSelect} />;
      })}
    </TreeView>
  );
}
